import * as types from "../constants/ActionTypes";

const initialState = {
    userConfirmInfo: undefined
}

export default function confirmInfoReducer(state = initialState, action) {
    if (action.type === types.SET_CONFIRMINFO) {
        return { userConfirmInfo: action.data }
    }
    
    return state;
}